import { Moment } from 'moment';
import { IUser } from './user.model';
import { IBook } from './book.model';

export interface ISport {
  id?: number;
  name?: string;
  iconName?: string;
  createdDate?: Moment;
  lastModifiedDate?: Moment;
  createdBy?: IUser;
  lastModifiedBy?: IUser;
  names?: IBook[];
}

export const defaultValue: Readonly<ISport> = {};
